export class Constants {
  public static readonly dateFormatUI: string = 'DD.MM.yyyy';
  public static readonly dateFormatDB: string = 'yyyy-MM-DD';
  public static readonly dateTimeFormatUI: string = 'DD-MM-yyyy HH:mm:ss';

  public static readonly kgbAppLink: string = 'https://links.kimgbister.com/bireysel-landing-button';
  public static readonly metaByteLink: string = 'https://www.1gb.kim/';
}
